export const fetchProductAvailability = (fetchData, produtoId) => (
  fetchData('/ProdutoDelivery/Disponibilidade', { produtoId })
);

export const getProductAvailabilityPresentation = ({
  disponibilidade,
  erro,
  carregando,
  verificando
}) => ({
  bloqueado:
    Boolean(carregando) ||
    Boolean(verificando) ||
    Boolean(erro) ||
    disponibilidade?.disponivelAgora === false,
  mensagem:
    erro ||
    (disponibilidade?.disponivelAgora === false ? disponibilidade?.mensagem || '' : '')
});
